import {useDispatch} from 'react-redux';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Form, Modal} from 'semantic-ui-react';
import {toast} from 'react-toastify';
import {qrGenerationErrorHandler} from '../../objects/QRStickerGridPdfCreator';
import {defaultGridTemplateProvider} from '../../objects/StickerGridTemplate';

function DownloadStickersModal({
                                   downloadStickersTriggerComponent,
                                   createPDFActionMapper,
                                   selectedItemsSupplier,
                                   itemsLabelsSupplier,
                                   itemsLabelResultMapper,
                                   urlTemplateMapper,
                                   gridTemplateCreatorOptions,
                                   downloadFileName,
                               }) {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [openModal, setOpenModal] = useState(false);
    const [emptyStickers, setEmptyStickers] = useState(0);
    const [gridTemplateCreator, setGridTemplateCreator] = useState(() => defaultGridTemplateProvider);

    const numericInputChangeHandler = inputText => {
        const numericValue = inputText.replace(/[^0-9]/, '');
        setEmptyStickers(numericValue);
    };

    return (
        <Modal
            onClose={() => {
                setEmptyStickers(0);
                setOpenModal(false);
            }}
            open={openModal}
            trigger={downloadStickersTriggerComponent(setOpenModal)}
        >
            <Modal.Header>{t('download.stickers.modal.title')}</Modal.Header>
            <Modal.Content>
                <Form>
                    <Form.Select
                        label={t('download.stickers.modal.grid.selection')}
                        options={gridTemplateCreatorOptions}
                        value={gridTemplateCreator}
                        onChange={(ignored, {value}) => setGridTemplateCreator(() => value)}
                    />
                    <Form.Input
                        label={t('download.stickers.modal.empty.number')}
                        value={emptyStickers}
                        onFocus={e => e.target.select()}
                        onChange={(ignored, {value}) => numericInputChangeHandler(value)}
                    />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    color="red"
                    onClick={() => {
                        setEmptyStickers(0);
                        setOpenModal(false);
                    }}
                >
                    {t('cancel.button')}
                </Button>
                <Button
                    positive
                    disabled={isNaN(Number(emptyStickers))}
                    onClick={() => {
                        dispatch(
                            createPDFActionMapper(
                                gridTemplateCreator(Number(emptyStickers)),
                                selectedItemsSupplier(),
                                itemsLabelsSupplier,
                                itemsLabelResultMapper,
                                urlTemplateMapper,
                                downloadFileName,
                                qrGenerationErrorHandler(t)
                            )
                        );
                        setOpenModal(false);
                        toast.success(
                            t('download.stickers.success.generating.stickers')
                        );
                    }}
                >
                    {t('download.stickers.button.label')}
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default DownloadStickersModal;
